/**
 * Generated from IntroLayout.fla
 */
export function IntroLayout(this: IIntroLayout) {
	const duck = this.duck;
	if (!duck[0] && duck.elementFactory) {
		duck[0] = duck.elementFactory(0,undefined);
	}
	if (duck[0]) {
		IntroLayout_duck.call(duck[0] as IIntroLayout_duck);
		duck[0].x = 767.5;
		duck[0].y = 261.05;
		duck[0].width = 151.05;
		duck[0].height = 132.10;
		if (duck[0].onLayout) duck[0].onLayout();
	}
	if (!duck[1] && duck.elementFactory) {
		duck[1] = duck.elementFactory(1,undefined);
	}
	if (duck[1]) {
		IntroLayout_duck2.call(duck[1] as IIntroLayout_duck2);
		duck[1].x = 646.6;
		duck[1].y = 262.35;
		duck[1].width = 148.11;
		duck[1].height = 129.51;
		if (duck[1].onLayout) duck[1].onLayout();
	}
	if (!duck[2] && duck.elementFactory) {
		duck[2] = duck.elementFactory(2,undefined);
	}
	if (duck[2]) {
		IntroLayout_duck3.call(duck[2] as IIntroLayout_duck3);
		duck[2].x = 537.5;
		duck[2].y = 252.05;
		duck[2].width = 141.91;
		duck[2].height = 124.10;
		if (duck[2].onLayout) duck[2].onLayout();
	}
	if (!duck[3] && duck.elementFactory) {
		duck[3] = duck.elementFactory(3,undefined);
	}
	if (duck[3]) {
		IntroLayout_duck4.call(duck[3] as IIntroLayout_duck4);
		duck[3].x = 412.45;
		duck[3].y = 266.55;
		duck[3].width = 148.56;
		duck[3].height = 129.91;
		if (duck[3].onLayout) duck[3].onLayout();
	}
	if (!duck[4] && duck.elementFactory) {
		duck[4] = duck.elementFactory(4,undefined);
	}
	if (duck[4]) {
		IntroLayout_duck5.call(duck[4] as IIntroLayout_duck5);
		duck[4].x = 307.55;
		duck[4].y = 260.05;
		duck[4].width = 139.35;
		duck[4].height = 121.85;
		if (duck[4].onLayout) duck[4].onLayout();
	}
	const bg = this.bg;
	IntroLayout_bg.call(this.bg);
	bg.x = 511.5;
	bg.y = 385;
	bg.width = 1629.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const skipButton = this.skipButton;
	IntroLayout_skipButton.call(this.skipButton);
	skipButton.x = 925.55;
	skipButton.y = 715.75;
	skipButton.width = 131.00;
	skipButton.height = 82.50;
	if (skipButton.onLayout) skipButton.onLayout();
	const matt = this.matt;
	IntroLayout_matt.call(this.matt);
	matt.x = 707.8;
	matt.y = 753;
	matt.width = 270.50;
	matt.height = 375.50;
	if (matt.onLayout) matt.onLayout();
	const jackie = this.jackie;
	IntroLayout_jackie.call(this.jackie);
	jackie.x = 143;
	jackie.y = 722.95;
	jackie.width = 270.00;
	jackie.height = 381.50;
	if (jackie.onLayout) jackie.onLayout();
	const inez = this.inez;
	IntroLayout_inez.call(this.inez);
	inez.x = 429.05;
	inez.y = 692.9;
	inez.width = 270.00;
	inez.height = 338.00;
	if (inez.onLayout) inez.onLayout();
	const digit = this.digit;
	IntroLayout_digit.call(this.digit);
	digit.x = 882.05;
	digit.y = 599.95;
	digit.width = 226.50;
	digit.height = 246.00;
	if (digit.onLayout) digit.onLayout();
	const progressBarBg = this.progressBarBg;
	IntroLayout_progressBarBg.call(this.progressBarBg);
	progressBarBg.x = 512;
	progressBarBg.y = 114.7;
	progressBarBg.width = 427.00;
	progressBarBg.height = 58.00;
	if (progressBarBg.onLayout) progressBarBg.onLayout();
	const progressBarFill = this.progressBarFill;
	IntroLayout_progressBarFill.call(this.progressBarFill);
	progressBarFill.x = 302.5;
	progressBarFill.y = 114.25;
	progressBarFill.width = 419.00;
	progressBarFill.height = 49.00;
	if (progressBarFill.onLayout) progressBarFill.onLayout();
	const progressBarStartIcon = this.progressBarStartIcon;
	IntroLayout_progressBarStartIcon.call(this.progressBarStartIcon);
	progressBarStartIcon.x = 305;
	progressBarStartIcon.y = 107;
	progressBarStartIcon.width = 122.00;
	progressBarStartIcon.height = 80.00;
	if (progressBarStartIcon.onLayout) progressBarStartIcon.onLayout();
	const progressBarRestStopMarkerVisited = this.progressBarRestStopMarkerVisited;
	IntroLayout_progressBarRestStopMarkerVisited.call(this.progressBarRestStopMarkerVisited);
	progressBarRestStopMarkerVisited.x = 430.95;
	progressBarRestStopMarkerVisited.y = 85.75;
	progressBarRestStopMarkerVisited.width = 57.00;
	progressBarRestStopMarkerVisited.height = 77.00;
	if (progressBarRestStopMarkerVisited.onLayout) progressBarRestStopMarkerVisited.onLayout();
	const progressBarRestStopMarker = this.progressBarRestStopMarker;
	IntroLayout_progressBarRestStopMarker.call(this.progressBarRestStopMarker);
	progressBarRestStopMarker.x = 576.7;
	progressBarRestStopMarker.y = 85.75;
	progressBarRestStopMarker.width = 57.00;
	progressBarRestStopMarker.height = 77.00;
	if (progressBarRestStopMarker.onLayout) progressBarRestStopMarker.onLayout();
	const progressBarDestinationIcon = this.progressBarDestinationIcon;
	IntroLayout_progressBarDestinationIcon.call(this.progressBarDestinationIcon);
	progressBarDestinationIcon.x = 723.25;
	progressBarDestinationIcon.y = 108;
	progressBarDestinationIcon.width = 124.00;
	progressBarDestinationIcon.height = 105.50;
	if (progressBarDestinationIcon.onLayout) progressBarDestinationIcon.onLayout();
	return this;
}
function IntroLayout_bg(this: IIntroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-bg@1x.jpg", 0.500, 0.500);
	return this;
}
function IntroLayout_skipButton(this: IIntroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-skip-btn.png", 0.500, 0.500);
	return this;
}
function IntroLayout_matt(this: IIntroLayout_matt) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-characters-matt.png", 0.500, 1.000);
	return this;
}
function IntroLayout_jackie(this: IIntroLayout_jackie) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-characters-jackie.png", 0.500, 1.000);
	return this;
}
function IntroLayout_inez(this: IIntroLayout_inez) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-characters-inez.png", 0.500, 1.000);
	return this;
}
function IntroLayout_digit(this: IIntroLayout_digit) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-characters-digit.png", 0.500, 1.000);
	return this;
}
function IntroLayout_duck(this: IIntroLayout_duck) {
	if (this.setLayoutTexture) this.setLayoutTexture("Cyberchase_Duck3QEllerd_Frames_01.png", 0.500, 0.500);
	return this;
}
function IntroLayout_duck2(this: IIntroLayout_duck2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Cyberchase_Duck3QGenFem_Frames_01.png", 0.500, 0.500);
	return this;
}
function IntroLayout_duck3(this: IIntroLayout_duck3) {
	if (this.setLayoutTexture) this.setLayoutTexture("Cyberchase_Duck3QGenMale_Frames_03.png", 0.500, 0.500);
	return this;
}
function IntroLayout_duck4(this: IIntroLayout_duck4) {
	if (this.setLayoutTexture) this.setLayoutTexture("Cyberchase_Duck3QGenFem_Frames_01.png", 0.500, 0.500);
	return this;
}
function IntroLayout_duck5(this: IIntroLayout_duck5) {
	if (this.setLayoutTexture) this.setLayoutTexture("Cyberchase_Duck3QGenFem_Frames_04.png", 0.500, 0.500);
	return this;
}
function IntroLayout_progressBarBg(this: IIntroLayout_progressBarBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-progress-bar-emptyl.png", 0.500, 0.500);
	return this;
}
function IntroLayout_progressBarFill(this: IIntroLayout_progressBarFill) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-progress-bar-full.png", 0.000, 0.500);
	return this;
}
function IntroLayout_progressBarStartIcon(this: IIntroLayout_progressBarStartIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-startimg.png", 0.500, 0.500);
	return this;
}
function IntroLayout_progressBarRestStopMarkerVisited(this: IIntroLayout_progressBarRestStopMarkerVisited) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-checkpoint.png", 0.500, 1.000);
	return this;
}
function IntroLayout_progressBarRestStopMarker(this: IIntroLayout_progressBarRestStopMarker) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-checkpoint.png", 0.500, 1.000);
	return this;
}
function IntroLayout_progressBarDestinationIcon(this: IIntroLayout_progressBarDestinationIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-endimg.png", 0.500, 0.502);
	return this;
}
interface IIntroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IIntroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IIntroLayoutSprite extends IIntroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IIntroLayoutText extends IIntroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IIntroLayoutPolygon extends Array<number> {
}
interface IIntroLayout {
	readonly duck: IIntroLayoutArray<IIntroLayout_duck|IIntroLayout_duck2|IIntroLayout_duck3|IIntroLayout_duck4|IIntroLayout_duck5>;
	readonly bg: IIntroLayout_bg;
	readonly skipButton: IIntroLayout_skipButton;
	readonly matt: IIntroLayout_matt;
	readonly jackie: IIntroLayout_jackie;
	readonly inez: IIntroLayout_inez;
	readonly digit: IIntroLayout_digit;
	readonly progressBarBg: IIntroLayout_progressBarBg;
	readonly progressBarFill: IIntroLayout_progressBarFill;
	readonly progressBarStartIcon: IIntroLayout_progressBarStartIcon;
	readonly progressBarRestStopMarkerVisited: IIntroLayout_progressBarRestStopMarkerVisited;
	readonly progressBarRestStopMarker: IIntroLayout_progressBarRestStopMarker;
	readonly progressBarDestinationIcon: IIntroLayout_progressBarDestinationIcon;
}
interface IIntroLayout_bg extends IIntroLayoutSprite {
}
interface IIntroLayout_skipButton extends IIntroLayoutSprite {
}
interface IIntroLayout_matt extends IIntroLayoutSprite {
}
interface IIntroLayout_jackie extends IIntroLayoutSprite {
}
interface IIntroLayout_inez extends IIntroLayoutSprite {
}
interface IIntroLayout_digit extends IIntroLayoutSprite {
}
interface IIntroLayout_duck extends IIntroLayoutSprite {
}
interface IIntroLayout_duck2 extends IIntroLayoutSprite {
}
interface IIntroLayout_duck3 extends IIntroLayoutSprite {
}
interface IIntroLayout_duck4 extends IIntroLayoutSprite {
}
interface IIntroLayout_duck5 extends IIntroLayoutSprite {
}
interface IIntroLayout_progressBarBg extends IIntroLayoutSprite {
}
interface IIntroLayout_progressBarFill extends IIntroLayoutSprite {
}
interface IIntroLayout_progressBarStartIcon extends IIntroLayoutSprite {
}
interface IIntroLayout_progressBarRestStopMarkerVisited extends IIntroLayoutSprite {
}
interface IIntroLayout_progressBarRestStopMarker extends IIntroLayoutSprite {
}
interface IIntroLayout_progressBarDestinationIcon extends IIntroLayoutSprite {
}
